var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goodsCountTable" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.data,
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            border: "",
            "max-height": "500"
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_type_text", label: "类型" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "shop_name", label: "三方名称" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "sku_code", label: "锐锢编码" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "sku_name", label: "商品名称", width: "300" }
          }),
          _vm._v(" "),
          _c("el-table-column", { attrs: { prop: "unit", label: "单位" } }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "order_price", label: "供货成交价" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "sum_order_quantity", label: "数量" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("fixedNumber")(scope.row.sum_order_quantity)
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "sum_order_amount", label: "供货金额" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-478fba0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-478fba0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/GoodsCountTable.vue
// module id = null
// module chunks = 